<template>
	<div>
		<v-select
			class="body-1 area-filter"
			color="primary"
			:height="36"
			hide-details
			item-text="name"
			item-value="id"
			:items="areas"
			outline
			:menu-props="{ contentClass: 'type-select-content' }"
			:style="`color:${$appColors.primary}!important`"
			:value="areaSelected"
			@input="$emit('change-area', $event)"
		></v-select>
	</div>
</template>

<script>
	export default {
		name: 'area-filter',
		props: {
			areas: {
				default: () => [],
				type: Array,
			},
			areaSelected: [Number, String],
		},
	};
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/diagnosis/area-filter.vue